(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.announcement = this.header.previousElementSibling?.classList.contains('announcement-bar-section')
        ? this.header.previousElementSibling
        : null;
      this.homepageHeroTop = 0;
      this.homepageHeroScrollDistance = 0;
      this.homepageHeroPinEnd = 0;
      this.isHomepageHeaderLocked = false;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateHomepageHeaderMeasurements = this.refreshHomepageHeaderMeasurements.bind(this);

      this.refreshHomepageHeaderMeasurements();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.updateHomepageHeaderMeasurements);
      window.addEventListener('load', this.updateHomepageHeaderMeasurements, { once: true });
      document.addEventListener('shopify:section:load', this.updateHomepageHeaderMeasurements);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementHeight() {
      if (!this.header.querySelector('.encore-header-homepage')) return;

      const announcementHeight = this.announcement ? this.announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--encore-announcement-height', `${announcementHeight}px`);
    }

    refreshHomepageHeaderMeasurements() {
      if (!this.header.querySelector('.encore-header-homepage')) return;

      this.setAnnouncementHeight();

      const hero = document.querySelector('[data-encore-hero]');
      if (!hero) {
        this.homepageHeroTop = 0;
        this.homepageHeroScrollDistance = 0;
        this.homepageHeroPinEnd = 0;
        this.unlockHomepageHeader();
        return;
      }

      const heroTop = hero.getBoundingClientRect().top + window.pageYOffset;
      const heroScrollDistance = Math.max(hero.offsetHeight - window.innerHeight, 1);

      this.homepageHeroTop = heroTop;
      this.homepageHeroScrollDistance = heroScrollDistance;
      this.homepageHeroPinEnd = heroTop + heroScrollDistance;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.isHomepageHeroPinned(scrollTop)) {
        this.forceHeaderVisible(scrollTop);
      } else {
        this.unlockHomepageHeader();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.updateHomepageHeaderMeasurements);
      document.removeEventListener('shopify:section:load', this.updateHomepageHeaderMeasurements);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const shouldLockHomepageHeader = this.isHomepageHeroPinned(scrollTop);

      if (shouldLockHomepageHeader) {
        if (!this.isHomepageHeaderLocked) {
          this.forceHeaderVisible(scrollTop);
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.isHomepageHeaderLocked) {
        this.unlockHomepageHeader();
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    isHomepageHeroPinned(scrollTop) {
      if (!this.header.querySelector('.encore-header-homepage')) return false;
      if (!this.homepageHeroScrollDistance) return false;

      return scrollTop >= this.homepageHeroTop && scrollTop < this.homepageHeroPinEnd;
    }

    forceHeaderVisible(scrollTop) {
      this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.lockHomepageHeader();
      this.currentScrollTop = scrollTop;
    }

    lockHomepageHeader() {
      if (this.isHomepageHeaderLocked) return;
      this.isHomepageHeaderLocked = true;
      this.header.classList.add('encore-homepage-header-locked');
      this.announcement?.classList.add('encore-homepage-header-locked');
    }

    unlockHomepageHeader() {
      if (!this.isHomepageHeaderLocked) return;
      this.isHomepageHeaderLocked = false;
      this.header.classList.remove('encore-homepage-header-locked');
      this.announcement?.classList.remove('encore-homepage-header-locked');
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.isHomepageHeroPinned(scrollTop)) {
        if (!this.isHomepageHeaderLocked) {
          this.forceHeaderVisible(scrollTop);
        }
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.isHomepageHeroPinned(scrollTop)) {
        if (!this.isHomepageHeaderLocked) {
          this.forceHeaderVisible(scrollTop);
        }
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
